export default class {
    content = [];
    totalElements = 0;
    totalPages = 0
}
